import { confirmAlert } from 'react-confirm-alert';

import { DeletePermissionTagsConfirmation } from './DeletePermissionTagsConfirmation';

interface ConfirmDeletePermissionTagsProps {
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
}
export function confirmDeletePermissionTags({
  onConfirm,
  onReject,
}: ConfirmDeletePermissionTagsProps): void {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <DeletePermissionTagsConfirmation
          onConfirm={() => {
            onConfirm();
            onClose();
          }}
          onReject={() => {
            onReject?.();
            onClose();
          }}
        />
      );
    },
  });
}
